import { useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { useHeadManager } from '@/lib/headManagerProvider'
import { faqs } from '@/mock/mock-data-home'

export function FrequentlyAsked() {
  const { setTitle } = useHeadManager()
  const [search, setSearch] = useState('')

  useEffect(() => {
    setTitle('Perguntas Frequentes')
  }, [setTitle])

  const faqsFiltradas = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(search.toLowerCase()),
  )

  return (
    <div className="px-6 py-10">
      <h2 className="text-muted-foreground text-center text-3xl font-bold">
        Perguntas Frequentes
      </h2>

      <div className="mx-auto mt-6 max-w-3xl">
        <Input
          type="text"
          placeholder="Buscar pergunta..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full"
        />
      </div>

      <div className="mt-15 grid grid-cols-1 gap-6 md:grid-cols-3">
        {faqsFiltradas.length > 0 ? (
          faqsFiltradas.map((faq, idx) => (
            <Card
              key={idx}
              style={{ backgroundColor: 'var(--primary)' }}
              className="p-4 text-white shadow-md"
            >
              <CardContent>
                <p className="text-base font-semibold">{faq.question}</p>
                <p className="mt-2 text-sm text-white/90">{faq.answer}</p>
                <div className="mt-4 border-t border-white/20 pt-2 text-end">
                  <Button variant="link" className="text-white">
                    Saiba mais
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))
        ) : (
          <p className="text-muted-foreground col-span-full mt-4 text-center text-sm">
            Nenhuma pergunta encontrada.
          </p>
        )}
      </div>
    </div>
  )
}
